<script>
  import { TabContent } from 'carbon-components-svelte';

  import TabsWithRouting from '../../components/TabsWithRouting.svelte';
  import LazyLoadedTabContent from '../../components/LazyLoadedTabContent.svelte';

  import AdminBasicInformation from './AdminBasicInformation.svelte';
  import AdminCloudfrontBuckets from './AdminCloudfrontBuckets.svelte';
  import AdminFlags from './AdminFlags.svelte';
</script>

<TabsWithRouting
  tabsWrapperProps={{ 'aria-label': 'Admin Dashboard module tabs' }}
  tabs={[
    { label: 'Basic Information', hash: '#basic-information' },
    { label: 'CloudFront Buckets', hash: '#cloudfront-buckets' },
    { label: 'Flags', hash: '#flags' },
  ]}
>
  <TabContent><AdminBasicInformation /></TabContent>
  <LazyLoadedTabContent hash="#cloudfront-buckets"><AdminCloudfrontBuckets /></LazyLoadedTabContent>
  <LazyLoadedTabContent hash="#flags"><AdminFlags /></LazyLoadedTabContent>
</TabsWithRouting>
